import React, {useEffect,useState} from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import './assets/bootstrap-4.3.1-dist/css/bootstrap.min.css';
import './assets/bootstrap-4.3.1-dist/css/bootstrap.css';
import './App.css'; 
import { useAuth } from './Context/AuthContext';
import Home from './pages/Home';
import Admin from './pages/Admin';
import Header from './components/Header';
import About from './pages/About';
import Shop from './pages/Shop';
import Booking from './pages/Booking';
import CheckoutPage from './pages/CheckoutPage';
import Login from './pages/Login';
import Profile from './pages/Profile';
import ViewOrders from './components/Profile/ViewOrders';
import ViewBookings from './components/Profile/ViewBookings';
import Confirmaton from './pages/Confirmaton';



function App() {
  const { authUser, isLoggedIn , setAuthUser ,setIsLoggedIn } =useAuth();
  const [userData, setUserData] = useState({
    ID: null,
    Title: null,
    FName: null,
    LName: null,
    AccountType: null,
    Password: null,
    EmailAddress: null,
    userSocialLink:null,
    ContactNumber: null,
    StreetAddress: null,
    City: null,
    Province: null,
    County: null,
    Code: null,
    LocalOrInt: null,
    Points: null,
    OrdersActive: null,
    PastOrders: null,
    AccountStatus: null,
    DateJoined: null,
    DateDeactivated: null,
    LoggedIn:false

  });
  
  useEffect(() => {
    // Dynamically create script element
    const script = document.createElement('script');
    script.src = 'assets/scripts/main-script.js';
    script.async = true;

    // Append the script to the document body
    document.body.appendChild(script);

    // Cleanup: Remove the script when the component unmounts
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (  

      <Router>
        <div>
          <Helmet>
            <title>ByWaldo App</title>
            <link rel="icon" type="image/x-icon" href="assets/imgs/bywaldo-w.png" />
          </Helmet>
        
          {authUser ? (
          <>
            <Header />
            <Routes>
              <Route path="/" element={<Home />} />
              {/* <Route path="/admin" element={<Admin />} />
              <Route path="/Magazine" element={<About />} />
              <Route path="/Catalog" element={<Shop />} />
              <Route path="/Booking" element={<Booking />} />
              <Route path="/Checkout" element={<CheckoutPage />} />
              <Route path="/Confirmation" element={<Confirmaton />} />
              <Route path="/Login" element={<Login />} />
              <Route path="/Profile" element={<Profile />} />
              <Route path="/MyOrders" element={<ViewOrders />} />
              <Route path="/MyBookings" element={<ViewBookings />} /> */}
            </Routes>
          </>
        ) : null}
        

        </div>
      </Router>

    
  );
}

export default App;
